import { render } from "./register-step-four.vue?vue&type=template&id=503baef4"
import script from "./register-step-four.vue?vue&type=script&lang=js"
export * from "./register-step-four.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__